import { SelectedWorks } from "@/components/SelectedWorks";

/** The work, on its own page. The section's header is the page header. */
export default function Work() {
  return (
    <main className="bg-cream text-ink no-x pt-[76px]" data-testid="work-page">
      <SelectedWorks />
    </main>
  );
}
